<app-gradient class="gradient gradient__left"></app-gradient>
<app-gradient class="gradient gradient__right"></app-gradient>
<div class="home-purpose__container">
  <h2 class="heading-m home-purpose__title">
    {{ 'home.purpose-section.title' | translate }}
  </h2>
  <div class="home-card__container">
    <app-vertical-step-card
      icon="website-icon"
      title="{{ 'home.purpose-section.find-inspiration-title' | translate }}"
      description="{{
        'home.purpose-section.find-inspiration-description' | translate
      }}">
    </app-vertical-step-card>
    <app-vertical-step-card
      icon="perfume-icon"
      title="{{ 'home.purpose-section.receive-fragrance-title' | translate }}"
      description="{{
        'home.purpose-section.receive-fragrance-description' | translate
      }}">
    </app-vertical-step-card>
    <app-vertical-step-card
      icon="man-flag-icon"
      title="{{ 'home.purpose-section.launch-product-title' | translate }}"
      description="{{
        'home.purpose-section.launch-product-description' | translate
      }}">
    </app-vertical-step-card>
  </div>
  <app-button
    routerLink="/protected/capture-needs"
    type="primary"
    size="large"
    text="{{ 'home.purpose-section.start-creating' | translate }}"
    icon="north_east"></app-button>
</div>
